import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import './styles/globals.css';
import { App } from './App';
import { useThemeEffect } from './lib/theme';
import { appBuildSha } from './lib/version';
import { RealtimeBridge } from './lib/realtime';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

function Root() {
  useThemeEffect();
  return (
    <QueryClientProvider client={queryClient}>
      <RealtimeBridge queryClient={queryClient} />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);

// Register service worker in production builds only — Vite dev HMR doesn't play
// nice with caching, and we don't want stale-asset surprises while iterating.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`/sw.js?v=${encodeURIComponent(appBuildSha)}`).catch(() => {
      /* SW is best-effort */
    });
  });
}
